import { useEffect, useState } from 'react';
import WordCounter from '../../../../common/WordCounter';
import { useCurrentEditor } from '@tiptap/react';
import { EditorEvents } from '@tiptap/core';
import { getContentSerializer } from '../plugins/Content';

export default function EditorWordCounter() {
  const { editor } = useCurrentEditor();
  const [text, setText] = useState(editor?.getText() ?? '');
  useEffect(() => {
    if (!editor) return;
    const handleUpdate = ({ editor }: EditorEvents['update']) => {
      const getContent = getContentSerializer(editor);
      if (!getContent) return;
      setText(getContent());
    };
    editor.on('update', handleUpdate);
    return () => {
      editor.off('update', handleUpdate);
    };
  }, [editor]);
  if (!editor) return null;

  return <WordCounter text={text} active={editor.isEditable} />;
}
